/* Status actions */
export const FETCH_LOANS = 'FETCH_LOANS';
export const FETCH_LOANS_SUCCESS = 'FETCH_LOANS_SUCCESS';
export const FETCH_LOANS_ERROR = 'FETCH_LOANS_ERROR';

/* Drawer state actions */
export const OPEN_LOANS_DRAWER = 'OPEN_LOANS_DRAWER';
export const CLOSE_LOANS_DRAWER = 'CLOSE_LOANS_DRAWER';

/* loan status */
export const LOAN_STATUS = {
  DELIVERED: 'delivered',
  ACCEPTED: 'accepted',
  PAID_OUT: 'paid_out',
  FULLY_REPAID: 'fully_repaid',
};

export const LOAN_STATUS_ORDER = {
  [LOAN_STATUS.PAID_OUT]: 0,
  [LOAN_STATUS.ACCEPTED]: 1,
  [LOAN_STATUS.DELIVERED]: 2,
};

export const LOANS_FILTER = {
  ALL: null,
  PAID: [LOAN_STATUS.FULLY_REPAID],
  IN_PROGRESS: [LOAN_STATUS.DELIVERED, LOAN_STATUS.ACCEPTED, LOAN_STATUS.PAID_OUT],
};
